'use strict';

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');

var defaultValidationErrorReasons = [{
  name: 'typeMismatch'
}];

var getValidationResult = function getValidationResult(_ref) {
  var _event$target, _event$target2, _event$target3;

  var event = _ref.event,
      validationErrorReasons = _ref.validationErrorReasons;
  var browserErrorMessage = (event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.validationMessage) || '';
  var validityState = (event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.validity) || {};
  var matchedValidationErrorReason = [].concat(_rollupPluginBabelHelpers.toConsumableArray(validationErrorReasons), defaultValidationErrorReasons).find(function (_ref2) {
    var name = _ref2.name;
    return validityState[name];
  });

  var _ref3 = (event === null || event === void 0 ? void 0 : (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.validity) || {},
      _ref3$valid = _ref3.valid,
      browserValid = _ref3$valid === void 0 ? true : _ref3$valid; // implication: matchedValidationErrorReason -> browserValid


  var valid = !matchedValidationErrorReason || browserValid;

  var _ref4 = matchedValidationErrorReason || {},
      _ref4$message = _ref4.message,
      message = _ref4$message === void 0 ? browserErrorMessage : _ref4$message;

  return {
    valid: valid,
    message: message
  };
};

var getValidityChecker = function getValidityChecker(_ref5) {
  var validationErrorReasons = _ref5.validationErrorReasons,
      state = _ref5.state,
      setState = _ref5.setState;
  return function (event) {
    setState(_rollupPluginBabelHelpers.objectSpread2({}, state, {}, getValidationResult({
      event: event,
      validationErrorReasons: validationErrorReasons
    })));
  };
};

var useValidity = function useValidity(validationErrorReasons) {
  var _useState = React.useState({
    valid: true,
    message: ''
  }),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return [state, getValidityChecker({
    validationErrorReasons: validationErrorReasons,
    state: state,
    setState: setState
  })];
};

module.exports = useValidity;
